import React, { useState } from 'react'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'

import DocumentGenerateContext from 'contexts/DocumentGenerateContext'

import { routes } from 'Routes'
import * as service from 'service'
import useFetch from 'hooks/useFetch'

const DocumentGenerateProvider = ({ children }) => {
  const history = useHistory()

  const [activeStep, setActiveStep] = useState(0)
  const [lastActiveStep, setLastActiveStep] = useState(0)
  const [wantsToAdvanceStep, setWantsToAdvanceStep] = useState(false)
  const [wantsToReturnStep, setWantsToReturnStep] = useState(false)
  const [disabledNextButton, setDisabledNextButton] = useState(true)
  const [nextButtonText, setNextButtonText] = useState('Próximo')
  const [showBackButton, setShowBackButton] = useState(true)

  const [documentTemplate, setDocumentTemplate] = useState(null)
  const [documentVariables, setDocumentVariables] = useState([])
  const [documentVariablesFilled, setDocumentVariablesFilled] = useState({})
  const [documentGenerated, setDocumentGenerated] = useState(null)

  // Controle do Projeto de Governança que originou o fluxo, quando a criação começou pelo card de
  // uma evidência. É o que permite vincular o documento à evidência ao final e voltar para a atividade.
  const [controlOrigin, setControlOrigin] = useState(null)

  const { response } = useFetch(service.dponet.companyDocuments.getCategories, {
    listDocumentTemplateCategories: true,
  })

  const documentCategories = response?.data?.documentCategories || []

  // Para onde sair do fluxo devolve o usuário: a atividade de origem quando a criação começou por um
  // controle do Projeto de Governança. Fica centralizado aqui porque tanto o "Voltar" da primeira
  // etapa quanto a conclusão do fluxo precisam do mesmo destino.
  const controlOriginPath = controlOrigin
    ? reverse(routes.governanceProjects.activity.manage, {
        governanceProjectId: controlOrigin?.governanceProjectId,
        activityId: controlOrigin?.activityId,
      })
    : null

  const handleAdvanceStep = () => setWantsToAdvanceStep(true)

  const handleReturnStep = () => setWantsToReturnStep(true)

  const resetAdvanceStep = () => setWantsToAdvanceStep(false)

  const resetReturnStep = () => setWantsToReturnStep(false)

  const resetNextButtonText = () => setNextButtonText('Próximo')

  const enableNextButton = () => setDisabledNextButton(false)

  const hiddenBackButton = () => {
    setShowBackButton(false)
  }

  const resetBackButton = () => {
    setShowBackButton(true)
  }

  const handleNext = () => {
    resetAdvanceStep()
    enableNextButton()
    setLastActiveStep(activeStep)
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    resetReturnStep()

    if (activeStep === 0) {
      history.push(controlOriginPath || routes.documents.all)
      return
    }

    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const isStepComplete = (step) => {
    return step < activeStep
  }

  return (
    <DocumentGenerateContext.Provider
      value={{
        activeStep,
        controlOrigin,
        controlOriginPath,
        disabledNextButton,
        documentCategories,
        documentGenerated,
        documentTemplate,
        documentVariables,
        documentVariablesFilled,
        enableNextButton,
        handleAdvanceStep,
        handleBack,
        handleNext,
        handleReturnStep,
        hiddenBackButton,
        isStepComplete,
        lastActiveStep,
        nextButtonText,
        resetAdvanceStep,
        resetBackButton,
        resetNextButtonText,
        resetReturnStep,
        setActiveStep,
        setControlOrigin,
        setDisabledNextButton,
        setDocumentGenerated,
        setDocumentTemplate,
        setDocumentVariables,
        setDocumentVariablesFilled,
        setLastActiveStep,
        setNextButtonText,
        setShowBackButton,
        setWantsToAdvanceStep,
        setWantsToReturnStep,
        showBackButton,
        wantsToAdvanceStep,
        wantsToReturnStep,
      }}
    >
      {children}
    </DocumentGenerateContext.Provider>
  )
}

export default DocumentGenerateProvider
